export default __webpack_public_path__ + "static/media/bg-sp.626f369f.png";